import type { ApplicantListItem } from "@/lib/api/applicants";
import { APPLICANT_STAGE_SEQUENCE } from "@/lib/applicant-stage-presentation";

/** The source URL owns the reading, also while stepping to the next visit. */
export function applicantReading(all: ApplicantListItem[], params: URLSearchParams): ApplicantListItem[] {
  const requested = params.get("stage") ?? "";
  const stage = (APPLICANT_STAGE_SEQUENCE as readonly string[]).includes(requested) ? requested : "";
  const requestedProgram = params.get("program") ?? "";
  const program = all.some(row => row.program_id === requestedProgram) ? requestedProgram : "";
  const q = (params.get("q") ?? "").trim().toLocaleLowerCase();
  const sort = params.get("sort") ?? "applied";
  const descending = params.get("dir") === "desc" ? -1 : 1;
  return all.filter(row => (!stage || row.stage === stage) && (!program || row.program_id === program)
    && (!q || row.name.toLocaleLowerCase().includes(q) || row.email.toLocaleLowerCase().includes(q)))
    .sort((a, b) => descending * (sort === "name" ? a.name.localeCompare(b.name) : sort === "stage" ? APPLICANT_STAGE_SEQUENCE.indexOf(a.stage) - APPLICANT_STAGE_SEQUENCE.indexOf(b.stage) : b.applied_date.localeCompare(a.applied_date)));
}
